import React from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import Switch from '@mui/material/Switch'
import FloRadioGroup from '../common/form-elements/FloRadioGroup'
import { CodConfirmationRadioGroupOptions } from './FraudentOrdersConfig'
import { useRtoSuiteContext } from 'src/lib/contexts/RTOSuiteProvider'

import { useRTOSuitePermissions } from 'src/lib/access-permission-hooks/useRTOSuitePermissions'

const FraudulentOrders = () => {
  const { t } = useLocale()
  const codConfig = useRtoSuiteContext(context => context.state?.codVerification)
  const setVerifyCod = useRtoSuiteContext(context => context.actions.setVerifyCod)
  const { canEditRTOSuite } = useRTOSuitePermissions()
  return (
    <>
      <div className='border-t-1'></div>
      <div className='flex flex-col gap-2 pt-4' data-track-id='otp-verification-for-guest-user-section'>
        <div className='flex flex-row justify-between'>
          <div className='flex flex-col gap-1 text-sm'>
            <h2 className='font-medium text-carbon'>{t('otp_verification_for_guest_user')}</h2>
            <p className='font-normal leading-5 text-gray-dark'>{t('otp_verification_description')}</p>
          </div>
          <Switch
            disabled={!canEditRTOSuite}
            checked={codConfig === 'NO_VERIFICATION' ? false : true}
            onChange={() => {
              if (codConfig === 'NO_VERIFICATION') {
                setVerifyCod('POST_COD')
              } else {
                setVerifyCod('NO_VERIFICATION')
              }
            }}
          />
        </div>
        <FloRadioGroup
          groupName={'otp-verification'}
          options={CodConfirmationRadioGroupOptions}
          selectedOption={codConfig === 'NO_VERIFICATION' ? 'POST_COD' : codConfig}
          setSelectedOption={(radioSelectedOption: string) => {
            setVerifyCod(radioSelectedOption)
          }}
          customClassName='pt-1 text-#4D4D4D'
          isDisabled={canEditRTOSuite ? codConfig === 'NO_VERIFICATION' : true}
        />
      </div>
    </>
  )
}

export default FraudulentOrders
